"use client"

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { z } from "zod"
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/Components/ui/form"
import { Input } from "@/Components/ui/input"

import { useContext, useEffect } from 'react'
import { PlanBuilderContext } from './Plan'
import { NotebookTabs } from "lucide-react"

interface FrmAddMultipleTasksProps {
    setDialogOpen?: (open: boolean) => void;
}

const formSchema = z.object({
    numberOfTasks: z.coerce.number()
        .min(1, "At least one task is required")
        .max(25, "You can add a maximum of 25 tasks at once"),
})

const FrmAddMultipleTasks = ({setDialogOpen} : FrmAddMultipleTasksProps) => {
    const props = useContext(PlanBuilderContext);
    
        const { reset, ...form } = useForm<z.infer<typeof formSchema>>({
            resolver: zodResolver(formSchema),
            defaultValues: {
                numberOfTasks: 1,
            },
        });
    
        useEffect(() => {
            reset({
                numberOfTasks: 1,
            });
        }, [reset]);
    
        function onSubmit(data: z.infer<typeof formSchema>) {
            props.addMultipleTasks(data.numberOfTasks);
            setDialogOpen?.(false);
        }

  return (
    <Form {...form} reset={reset}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
                <FormField
                    control={form.control}
                    name="numberOfTasks"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>How Many Tasks would you like to add? (max 25)</FormLabel>
                            <FormControl>
                                <Input placeholder="1...25" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <button className="flex flex-row button-default mx-auto" type="submit"><NotebookTabs className="w-6 h-6 mr-2" />Add Tasks</button>
            </form>
        </Form>
  )
}

export default FrmAddMultipleTasks